import React from "react";
import { cn } from "@/lib/utils";

export const MARSTICK_LOGO_URL = "/marstick-logo.jpeg";

export default function MarstickLogoMark({ className, imgClassName, alt = "Marstick logo" }) {
  return (
    <span className={cn("flex shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-ocean", className)}>
      <img
        src={MARSTICK_LOGO_URL}
        alt={alt}
        className={cn("h-full w-full object-contain", imgClassName)}
        loading="eager"
        decoding="async"
      />
    </span>
  );
}